import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-300 p-0">
      <div className="container mx-auto text-center">
        <p className="text-sm text-gray-600">
          &copy; {currentYear} Powered by{' '}
          <a 
            href="https://www.techcryptors.services/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="font-semibold text-gray-700 hover:underline"
          >
            Tech Cryptors Private Limited (TCIS)
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
